<template>
  <v-container fluid>
    <h3>Arqueo de caja</h3>
    <hr class="mt-1 mb-3"/>

    <v-card class="mb-3">
      <v-card-title>Filtros</v-card-title>

      <v-card-text class="pb-0">
        <v-row align="center" dense>

          <v-col cols="12" md="3">
            <date-input hide-details outlined label="Fecha" v-model="date" @input="fetch"
                        :clearable="false"></date-input>
          </v-col>

          <v-col cols="12" md="3">
            <v-select outlined hide-details v-model="shift" label="Turno" :items="shifts"
                      @change="fetch"></v-select>
          </v-col>

          <v-col cols="12" md="3">
            <div>
              <v-chip><b>Desde</b>: {{ dateFrom.format('YYYY-MM-DD HH:mm') }}</v-chip>
              <v-chip><b>Hasta</b>: {{ dateTo.format('YYYY-MM-DD HH:mm') }}</v-chip>
            </div>

          </v-col>
          <v-col cols="12" md="3">
            <v-chip><b>Ordenes</b>: {{ getOrdersQuantity }} (${{ getOrdersAmount.toFixed(0) }})</v-chip>
          </v-col>
        </v-row>
      </v-card-text>

      <!--INCOME/EXPENSES-->
      <v-card-title>Registros Adicionales</v-card-title>
      <v-card-text class="pb-0">

        <v-simple-table dense>
          <tbody>
          <tr>

            <th colspan="2" class="pt-2 pb-2">
              <v-text-field type="number" label="Efectivo en Caja" outlined hide-details dense
                            v-model.number="cashAtClose"></v-text-field>
            </th>
          </tr>

          <tr v-for="(income,index) in dailyBox.income" :key="'income_'+index">
            <th class="pt-2 pb-2">
              <v-text-field  background-color="blue lighten-4" dense outlined hide-details
                             label="Concepto Ingreso" v-model="income.concept"
                             @change="debounceBox"></v-text-field>
            </th>
            <th class="pt-2 pb-2">
              <v-text-field type="number" background-color="blue lighten-4" dense outlined hide-details
                            label="Monto Ingreso"
                            @change="debounceBox"
                            v-model.number="income.amount"></v-text-field>
            </th>
            <td>
              <v-btn icon @click="removeIncome(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>

          <tr v-for="(expense,index) in dailyBox.expenses" :key="'expense_'+index">
            <th class="pt-2 pb-2">
              <v-text-field background-color="red lighten-4" dense outlined hide-details
                            label="Concepto Egreso" v-model="expense.concept"
                            @change="debounceBox"></v-text-field>
            </th>
            <th class="pt-2 pb-2">
              <v-text-field background-color="red lighten-4" type="number" dense outlined hide-details
                            label="Monto Egreso"
                            @change="debounceBox"
                            v-model.number="expense.amount"></v-text-field>
            </th>
            <td>
              <v-btn icon @click="removeExpenses(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>



          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue white--text" small @click="addIncome">Agregar Ingreso</v-btn>
        <v-btn color="red white--text" small @click="addExpense">Agregar Egreso</v-btn>
      </v-card-actions>

    </v-card>

    <loading v-if="loading"></loading>

    <v-card class="mt-2" v-if="!loading && orders.length > 0">
      <v-card-title>EFECTIVO</v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
          <tr>
            <th>Concepto</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>


          <tr v-for="(row,index) in boxRows" :key="index">
            <th :class="{red: row.amount < 0, blue: row.amount > 0}" class="lighten-4">{{row.concept}}</th>
            <td :class="{red: row.amount < 0, blue: row.amount > 0}" class="lighten-4">{{
                currencyFormat(row.amount)
              }}
            </td>
          </tr>



          <!--TOTAL-->
          <tr>
            <th>Total</th>
            <td>{{ currencyFormat(getTotalAmount) }}</td>
          </tr>

          <tr>
            <th>Efectivo en Caja</th>
            <td>
              {{ currencyFormat(cashAtClose) }}
            </td>
          </tr>
          <tr>
            <th>Diferencia</th>
            <td>{{ currencyFormat(cashAtClose - getTotalAmount) }}</td>
          </tr>

          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-title>Transferencias</v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
          <tr>
            <th>Concepto</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>Debito</th>
            <td>{{ currencyFormat(debito) }}</td>
          </tr>
          <tr>
            <th>Transferencias Bancarias</th>
            <td>{{ currencyFormat(transferenciaBancaria) }}</td>
          </tr>
          <tr>
            <th>Transferencias Mercado Pago</th>
            <td>{{ currencyFormat(transferenciaMercadoPago) }}</td>
          </tr>

          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="print" color="primary"> <v-icon left>print</v-icon> Imprimir</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2" v-if="!loading && orders.length > 0">
      <v-card-title>Reporte detallado</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-tabs vertical v-model="tabs">
              <v-tab v-for="deliveryUser in getDeliveryUsers" :key="deliveryUser">
                <span>{{ deliveryUser ? deliveryUser : 'Mostrador' }}</span>
                <v-spacer></v-spacer>
                <span>{{ getOrdersQuantityByUser(deliveryUser) }} (${{
                    getOrdersAmountByUser(deliveryUser).toFixed(0)
                  }})</span>
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" sm="8">
            <v-tabs-items v-model="tabs">
              <v-tab-item v-for="deliveryUser in getDeliveryUsers" :key="deliveryUser">
                <order-report-detail
                    :delivery-user="deliveryUser"
                    :report="getReportByUser(deliveryUser)"
                    :orders="getOrdersByUser(deliveryUser)"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-alert v-else type="info">
      Sin datos para la fecha seleccionada
    </v-alert>

  </v-container>
</template>

<script>
import {DateInput, Dayjs, DayjsMixin} from "@dracul/dayjs-frontend"
import {Loading} from "@dracul/common-frontend";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import CashAuditProvider from "@/modules/delivery/providers/CashAuditProvider";
import OrderReportDetail from "@/modules/delivery/components/OrderReportDetail";
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";
import {userProvider} from "@dracul/user-frontend";
import DailyBoxProvider from "@/modules/delivery/providers/DailyBoxProvider";
import debounce from 'lodash.debounce';

export default {
  name: "ArqueoReportPage",
  components: {OrderReportDetail, DateInput, Loading},
  mixins: [CurrencyMixin, DayjsMixin],
  data() {
    return {
      loading: false,
      shifts: [
        {value: 'morning', text: 'Mañana'},
        {value: 'afternoon', text: 'Tarde'},
      ],
      date: Dayjs().startOf('day'),
      shift: null,
      morningShiftHour: 9,
      afternoonShiftHour: 16,
      orders: [],
      tabs: null,
      exportLoading: false,
      exportFile: null,
      ownDeliveryPeople: [],
      outsourcedDeliveryPeople: [],
      bills: [{concept: '', amount: 0}],
      cashAtClose: 0,
      dailyBox: {
        boxDate: Dayjs().startOf('day'),
        shift: null,
        income: [],
        expenses: []
      },
      debounceBox: null,
      delay: 500
    }
  },
  created() {
    this.debounceBox = debounce(this.createOrUpdateDailyBox, this.delay)
    this.currentShift()
    this.fetchDailyBox()
    this.fetchOwnDelivery()
    this.fetchOutsourcedDelivery()
    this.fetchOrders()
  },
  computed: {
    boxRows(){
      let rows = []

      //rows.push({concept: 'Efectivo en caja' , amount: this.cashOnBar })

      this.getOwnDeliveryPeople.forEach(ownDeliveryPerson => {
        rows.push({concept: `Efectivo Productos - Repartidor propio (${ ownDeliveryPerson.username })` , amount: parseInt(this.getReportByUserAndMethod(ownDeliveryPerson.username, 'CASH').itemsAmountWithDiscount) })
        rows.push({concept: `Costo Envío Transferencia - Repartidor propio (${ ownDeliveryPerson.username })` , amount: -(parseInt(this.getReportByUserAndMethod(ownDeliveryPerson.username, 'BANK_TRANSFER').deliveryCost)) })
        rows.push({concept: `Costo Envío Mercado Pago - Repartidor propio (${ ownDeliveryPerson.username })` , amount: -(parseInt(this.getReportByUserAndMethod(ownDeliveryPerson.username, 'MP_TRANSFER').deliveryCost)) })
      })
      this.getOutsourcedDeliveryPeople.forEach(outsourcedDeliveryPerson => {
        rows.push({concept: `Efectivo Total - Repartidor Tercerizado (${ outsourcedDeliveryPerson.username })` , amount: parseInt(this.getReportByUserAndMethod(outsourcedDeliveryPerson.username, 'CASH').totalAmount) })
      })

      this.dailyBox.income.forEach(income => {
        rows.push({concept: income.concept , amount: income.amount })

      })

      this.dailyBox.expenses.forEach(expense => {
        rows.push({concept: expense.concept , amount: -(expense.amount) })
      })

      return rows

    },
    getTotalAmount() {
      return this.boxRows.reduce((total, row) => total + row.amount, 0)
    },
    debito() {
      return this.getReportByMethod('DEBIT').totalAmount
    },
    transferenciaBancaria() {
      return this.getReportByMethod('BANK_TRANSFER').totalAmount
    },
    transferenciaMercadoPago() {
      return this.getReportByMethod('MP_TRANSFER').totalAmount
    },

    getBills() {
      return this.bills.filter(bill => bill.amount > 0)
    },
    getOwnDeliveryPeople() {
      return this.ownDeliveryPeople.filter(u => this.orders.some(o => o.deliveryUser && o.deliveryUser.username === u.username))
    },
    getOutsourcedDeliveryPeople() {
      return this.outsourcedDeliveryPeople.filter(u => this.orders.some(o => o.deliveryUser && o.deliveryUser.username === u.username))
    },
    dateFrom() {
      if (this.shift == 'morning') {
        return this.date.clone().startOf('day').add(this.morningShiftHour, 'hours')
      }
      if (this.shift == 'afternoon') {
        return this.date.clone().startOf('day').add(this.afternoonShiftHour, 'hours')
      }
      return this.date.startOf('day')
    },
    dateTo() {
      if (this.shift == 'morning') {
        return this.date.clone().startOf('day').add(this.afternoonShiftHour, 'hours')
      }
      if (this.shift == 'afternoon') {
        return this.date.clone().startOf('day').add(1, 'day').add(this.morningShiftHour, 'hours')
      }

      return this.date.startOf('day')
    },
    cashOnBar() {
      return this.orders.reduce((a, order) => {
        if (!order.deliveryUser && order.payment.method === 'CASH') {
          return a + order.totalAmount
        } else {
          return a
        }
      }, 0)
    },
    getDeliveryUsers() {
      return this.orders.reduce((a, v) => {
        if (v.deliveryUser && !a.includes(v.deliveryUser.username))
          a.push(v.deliveryUser.username)
        return a
      }, [''])
    },
    getOrdersByUser() {
      return deliveryUser => {
        return this.orders.filter(o => (!deliveryUser && !o.deliveryUser) || (o.deliveryUser && o.deliveryUser.username === deliveryUser))
      }
    },
    getOrdersByUserAndMethod() {
      return (deliveryUser, method) => {
        return this.orders.filter(o => (
            o.deliveryUser && o.deliveryUser.username === deliveryUser &&
            o.payment.method === method
        ))
      }
    },
    getReportByUserAndMethod() {
      return (deliveryUser, method) => {
        return this.getOrdersByUserAndMethod(deliveryUser, method).reduce((a, order) => {
          a.itemsAmount += order.totalAmount
          a.itemsAmountWithDiscount += (order.itemsAmount - order.totalDiscount)
          a.deliveryCost += order.deliveryFree ? 0 : order.delivery.cost
          a.totalAmount += order.totalAmount
          a.quantity += 1
          return a
        }, {quantity: 0, itemsAmount: 0, totalDiscount: 0, itemsAmountWithDiscount: 0, deliveryCost: 0, totalAmount: 0})
      }
    },

    getOrdersByMethod() {
      return (method) => {
        return this.orders.filter(o => (o.payment.method === method))
      }
    },
    getReportByMethod() {
      return (method) => {
        return this.getOrdersByMethod(method).reduce((a, order) => {
          a.itemsAmount += order.totalAmount
          a.itemsAmountWithDiscount += (order.itemsAmount - order.totalDiscount)
          a.deliveryCost += order.deliveryFree ? 0 : order.delivery.cost
          a.totalAmount += order.totalAmount
          a.quantity += 1
          return a
        }, {quantity: 0, itemsAmount: 0, totalDiscount: 0, itemsAmountWithDiscount: 0, deliveryCost: 0, totalAmount: 0})
      }
    },

    getReportByUser() {
      return deliveryUser => {

        let reports = [] //{method, quantity, amount}
        this.getOrdersByUser(deliveryUser).forEach(order => {
          let report = reports.find(r => r.method === order.payment.method)
          if (report) {
            report.quantity++
            report.itemsAmount += order.itemsAmount
            report.totalDiscount += order.totalDiscount
            report.itemsAmountWithDiscount += (order.itemsAmount - order.totalDiscount)
            report.deliveryCost += order.deliveryFree ? 0 : order.delivery.cost
            report.totalAmount += order.totalAmount
          } else {
            reports.push({
              method: order.payment.method,
              user: deliveryUser,
              quantity: 1,
              itemsAmount: order.itemsAmount,
              totalDiscount: order.totalDiscount,
              itemsAmountWithDiscount: (order.itemsAmount - order.totalDiscount),
              deliveryCost: order.deliveryFree ? 0 : order.delivery.cost,
              totalAmount: order.totalAmount
            })
          }

        })

        return reports
      }
    },
    getOrdersQuantity() {
      return this.orders.length
    },
    getOrdersAmount() {
      return this.orders.reduce((a, o) => a + o.totalAmount, 0)
    },
    getOrdersQuantityByUser() {
      return deliveryUser => this.getOrdersByUser(deliveryUser).length
    },
    getOrdersAmountByUser() {
      return deliveryUser => this.getOrdersByUser(deliveryUser).reduce((a, o) => a + o.totalAmount, 0)
    },
    tablePrintItems() {
      let table = ''
      for (let row of this.boxRows) {
        table += `<tr>
                    <td style="text-align: center;font-size: 18px; border: 1px solid grey;">${row.concept}</td>
                    <td style="text-align: right;font-size: 18px; border: 1px solid grey;">${row.amount}</td>
                   </tr>`
      }

      return table
    },
    getTsShift(){
      return this.$t('delivery.shift.' + this.shift)
    }

  },
  methods: {
    createOrUpdateDailyBox(){
      this.dailyBox.boxDate = this.date
      this.dailyBox.shift = this.shift
      console.log("Dailybox",this.dailyBox)
      DailyBoxProvider.createOrUpdateDailyBox(this.dailyBox)
          .then(r => {
            console.error("DailyBox",r.data.createOrUpdateDailyBox)
          })
          .catch(e => {
             console.error(e)
          })
    },
    async fetch(){
      this.clearDailyBox()
      await this.fetchDailyBox()
      await this.fetchOrders()
    },
    clearDailyBox(){
      this.dailyBox = {
        boxDate: this.date,
        shift: this.shift,
        income: [],
        expenses: []
      }
    },
    fetchDailyBox() {
      DailyBoxProvider.findDailyBoxByDateAndShift(this.date, this.shift)
          .then(r => {
            this.clearDailyBox()
            let dailyBox = r.data.findDailyBoxByDateAndShift

            if(dailyBox && dailyBox.income){
              this.dailyBox.income = dailyBox.income
            }
            if(dailyBox && dailyBox.expenses){
              this.dailyBox.expenses = dailyBox.expenses
            }
          })
          .catch(e => {
            console.log(e)

          })
    },
    removeIncome(index) {
      this.dailyBox.income.splice(index, 1)
      this.createOrUpdateDailyBox()

    },
    removeExpenses(index) {
      this.dailyBox.expenses.splice(index, 1)
      this.createOrUpdateDailyBox()
    },
    addIncome() {
      this.dailyBox.income.push({
        concept: '',
        amount: 0
      })
    },
    addExpense() {
      this.dailyBox.expenses.push({
        concept: '',
        amount: 0
      })
    },
    currentShift() {
      let now = Dayjs()
      if (now.hour() < 15) {
        this.shift = 'morning'
      } else {
        this.shift = 'afternoon'
      }
    },
    fetchOrders() {
      this.loading = true
      this.exportFile = null
      OrderProvider.orderFetchByStateBetweenDates(['READY', 'ON_THE_WAY', 'DELIVERED'], this.dateFrom, this.dateTo)
          .then(r => {
            this.orders = r.data.orderFetchByStateBetweenDates
          })
          .finally(() => this.loading = false)
    },
    cashAuditExport() {
      this.exportLoading = true
      CashAuditProvider.cashAuditExport(this.date)
          .then(r => {
            this.exportFile = r.data.cashAuditExport
          })
          .finally(() => this.exportLoading = false)
    },
    fetchOwnDelivery() {
      userProvider.usersByRole('repartidor').then(r => {
        this.ownDeliveryPeople = r.data.usersByRole
      })
    },
    fetchOutsourcedDelivery() {
      userProvider.usersByRole('repartidorTercerizado').then(r => {
        this.outsourcedDeliveryPeople = r.data.usersByRole
      })
    },

    print() {
      let printPreview = window.open('', 'print_preview');
      let printDocument = printPreview.document;
      printDocument.open();

      let head = "<head>" +
          "<style> .to-print{height:279mm; width:80mm; } </style>" +
          "</head>";
      let content = `
      <!DOCTYPE html>
      <html>${head}
      <body>
      <div class='to-print'>
      <h3 style="width: 100%;text-align: left; font-size: 26px; margin-bottom: 1px;">Arqueo de caja</h3>
      <span style="width: 100%;text-align: left; font-size: 20px;">${this.getDateFormat(this.date)} (${this.getTsShift })</span>
      <h3 style="width: 100%;text-align: left; font-size: 22px;">Efectivo</h3>
      <table style="width: 100%;text-align: left; font-size: 16px; border: 1px solid grey;">
        <thead>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;" >CONCEPTO</th>
            <th style="font-size: 18px; border: 1px solid grey; text-align: right">IMPORTE</th>
          </tr>
        </thead>
        <tbody>
        ${this.tablePrintItems}

        <tr>
          <th style="font-size: 18px; border: 1px solid grey;">Total</th>
          <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.getTotalAmount}</td>
        </tr>

        <tr>
          <th style="font-size: 18px; border: 1px solid grey;">Efectivo en Caja</th>
          <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.cashAtClose}</td>
        </tr>

        <tr>
          <th style="font-size: 18px; border: 1px solid grey;">Diferencia</th>
          <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${this.cashAtClose - this.getTotalAmount}</td>
        </tr>

        </tbody>
      </table>

      <br>
    <h3 style="width: 100%;text-align: left; font-size: 22px;">Electronico</h3>
      <table style="width: 100%;text-align: left; font-size: 16px; border: 1px solid grey;">
      <thead>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;" >CONCEPTO</th>
            <th style="text-align: right; font-size: 18px; border: 1px solid grey; text-align: right">IMPORTE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">Debito</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${ this.debito }</td>
          </tr>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">Transferencias Bancarias</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${ this.transferenciaBancaria }</td>
          </tr>
          <tr>
            <th style="font-size: 18px; border: 1px solid grey;">Transferencias Mercado Pago</th>
            <td style="text-align: right; font-size: 18px; border: 1px solid grey;">${ this.transferenciaMercadoPago }</td>
          </tr>
          </tbody>
        </table>

      <br><br><br><br>
      </div>
      </body></html>
      `
      printDocument.write(content);
      printPreview.print();
      printPreview.close()
    }
  }
}
</script>

<style scoped>
.red-label .v-label {
  color: red !important;
  opacity: 1;
}

.blue-label .v-label {
  color: blue  !important;
  opacity: 1;
}

</style>
